var exports = {
  "A": "default__oxxQZ0",
  "o": "compact__GgiZ8g",
};

module.exports = exports;
